import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { manualSync } from '../services/syncService';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isSyncing, setIsSyncing] = useState(false);

  const handleLogout = () => {
    logout();
  };

  const handleManualSync = async () => {
    setIsSyncing(true);
    try {
      const data = await manualSync();
      
      if (data.status === 'success') {
        alert('Синхронизация запущена успешно!');
      } else {
        alert('Ошибка при запуске синхронизации');
      }
    } catch (error) {
      console.error('Ошибка синхронизации:', error);
      alert('Ошибка при запуске синхронизации');
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <div className="logo">
            <h1>A-Casa Dashboard</h1>
          </div>
          <nav className="nav">
            <ul className="nav-menu">
              <li className="nav-item">
                <Link 
                  to="/" 
                  className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                >
                  Main
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/sync-logs" 
                  className={`nav-link ${location.pathname === '/sync-logs' ? 'active' : ''}`}
                >
                  Sync Logs
                </Link>
              </li>
              <li className="nav-item">
                <button 
                  onClick={handleManualSync}
                  disabled={isSyncing}
                  className="manual-sync-btn"
                >
                  {isSyncing ? 'Syncing...' : 'Manual Sync'}
                </button>
              </li>
            </ul>
          </nav>
          <div className="user-info">
            <span className="username">Welcome, {user?.username}</span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>
      
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout; 